export var OAUTH2=["google","apple","naver","discord","facebook","line"];